import { withJsonFormsControlProps } from "@jsonforms/react";
import { CustomRendererProps } from "../types";
import { EventSurveyManagement as Survey } from "layouts/aplicacoes/Events/components/EventSurveyManagement";

function EventSurveyManagement({ data, handleChange, path, enabled }: CustomRendererProps<any>) {
  return <Survey event={data} enabled={enabled} onChange={(value) => handleChange(path, value)} />;
}

export default withJsonFormsControlProps(EventSurveyManagement);
